import { default as ArticleCardWrapper } from './ArticleCard';
export * from './ArticleCard';
export * from './article-card-theme';
import ArticleCardFooter from './ArticleCardFooter';
import ArticleCardTitle from './ArticleCardTitle';
import ArticleCardSummary from './ArticleCardSummary';
import ArticleCardMeta from './ArticleCardMeta';

export type ArticleCardWrapper = typeof ArticleCardWrapper;

export interface ArticleCard extends ArticleCardWrapper {
  Title: typeof ArticleCardTitle;
  Summary: typeof ArticleCardSummary;
  Meta: typeof ArticleCardMeta;
  Footer: typeof ArticleCardFooter;
}

const ArticleCard: ArticleCard = ArticleCardWrapper as ArticleCard;

ArticleCard.Title = ArticleCardTitle;
ArticleCard.Summary = ArticleCardSummary;
ArticleCard.Meta = ArticleCardMeta;
ArticleCard.Footer = ArticleCardFooter;

export default ArticleCard;
